import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';

/**
 * useFeatureFlag('some-flag-key')
 *
 * Checks whether a Manage Changes flag is switched on for the CURRENT
 * logged-in user (Super Admin / specific user / Live — same resolution
 * order as the backend). Use this to show the old vs. new version of
 * anything gated behind a Manage Changes entry.
 *
 * Returns { enabled, loading }. While loading, `enabled` is false, so UI
 * defaults to the ORIGINAL behaviour until the check completes — a change
 * should never flash "on" before it's confirmed.
 */
export function useFeatureFlag(flagKey) {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!flagKey) {
      setLoading(false);
      return;
    }
    setLoading(true);
    axios
      .get(`${API}/feature-flags/${flagKey}`)
      .then((res) => {
        if (!cancelled) setEnabled(!!res.data?.enabled);
      })
      .catch(() => {
        if (!cancelled) setEnabled(false); // fail safe: default to original behaviour
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [flagKey]);

  return { enabled, loading };
}
